import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18n, FiverrContext } from '@fiverr-private/fiverr_context';
import { DEFAULT_LOCALE } from '@fiverr-private/fiverr_context/lib/constants';
import { PRO_BADGE_LOCALE_CLASS_MAPPER } from './constants';

import './style.scss';

const Pro = ({ proSubCategories }) => {
    const { locale = DEFAULT_LOCALE } = useContext(FiverrContext);

    const localeClass = PRO_BADGE_LOCALE_CLASS_MAPPER[locale] || '';
    const proVerifiedLabel = classNames('pro-verified', localeClass);

    return (
        <div className="pro-wrapper">
            <label className={proVerifiedLabel}><I18n k={'gig_page_perseus.seller_card.pro.verified_by'}/></label>
            <ul>
                {proSubCategories.map((subcategory) => (
                    <li key={subcategory.id}>
                        {subcategory.name}
                    </li>
                ))}
            </ul>
        </div>
    );
};

Pro.propTypes = {
    proSubCategories: PropTypes.array
};

export default Pro;
